import { useEffect } from "react";
import Button from "../../components/Button";
import FlexBox, { FlexGrow } from "../../components/FlexBox";
import { ClickableIcon } from "../../components/Icon";
import Input from "../../components/Input";
import Modal from "../../components/Modal";
import theme from "../../styles/theme";
import Status from "../../types/enum/Status";

export const PersonFilterModal = ({
  isOpen,
  filterData,
  mobile,
  inset,
  setOpen,
  confirmFunction,
  isPersonFiltered,
  setIsPersonFiltered,
  setFilterPerson,
  filterPerson,
  tempFilterPerson,
  setTempFilterPerson,
}: any) => {
  useEffect(() => {
    if (isOpen) {
      // Use setTimeout to delay the focus
      const timer = setTimeout(() => {
        const inputElement = document.getElementById("person");
        if (inputElement) {
          inputElement.focus();
        }
      }, 1); // Adjust the timeout as necessary

      return () => clearTimeout(timer); // Cleanup on unmount or when isOpen changes
    }
  }, [isOpen]);
  return (
    <Modal
      onClose={() => setFilterPerson(tempFilterPerson)}
      isOpen={isOpen || false}
      setOpen={setOpen}
      customStyle={{
        overlay: {
          background: "unset",
        },
        content: {
          maxWidth: mobile ? "300px" : "360px",
          width: "100%",
          height: "auto",
          padding: "16px 16px 24px 16px",
          background: "#1a1d2d",
          // backdropFilter: 'blur(35px)',
          boxShadow: "0 0 4px black",
          position: "absolute",
          inset: inset || "0px 0px auto auto",
          margin: `calc(${theme.navbarHeight} + ${theme.spacing.x10} + 70px) 2% auto calc(${theme.spacing.x4} + 420px)`,
        },
      }}
    >
      <div>
        {isPersonFiltered && (
          <div
            onClick={() => {
              const index: any = [];
              filterData.forEach((element: any) => {
                index.push(element.value);
              });
              setOpen(false);
              setIsPersonFiltered(false);
              setFilterPerson("");
              setTempFilterPerson("");
            }}
            style={{
              color: "#f7b53a",
              display: "flex",
              alignItems: "center",
              flexWrap: "nowrap",
              marginBottom: 5,
              justifyContent: "flex-end",
              cursor: "pointer",
            }}
          >
            <ClickableIcon onClick={() => {}} color="#f7b53a" name="times" />
            <div style={{ display: "flex", flexWrap: "nowrap" }}>
              Remove Filter
            </div>
          </div>
        )}
        <Input
          width={10}
          onInput={(e: React.ChangeEvent<HTMLInputElement>) => {
            setFilterPerson(e.target.value);
          }}
          required
          isFullWidth
          id="person"
          name="Responsible Person"
          placeholder="Responsible Person"
          value={filterPerson}
          style={{ color: "white" }}
        />
        <FlexBox
          justify="end"
          style={{ marginTop: "16px", flexWrap: "nowrap" }}
        >
          <FlexGrow style={{ flexGrow: "0" }}>
            <Button
              style={{
                width: mobile ? "150px" : "150px",
                height: "40px",
                padding: "13px 12px",
              }}
              isOutline
              onClick={() => {
                setOpen(false);
                setFilterPerson(tempFilterPerson);
              }}
              status={Status.default}
            >
              Cancel
            </Button>
          </FlexGrow>
          <FlexGrow style={{ flexGrow: "0" }}>
            <Button
              style={{
                width: mobile ? "150px" : "150px",
                height: "40px",
                padding: "13px 12px",
              }}
              status={Status.button}
              onClick={() => {
                confirmFunction();
                setOpen(false);
                setIsPersonFiltered(true);
                setTempFilterPerson(filterPerson);
              }}
            >
              Apply
            </Button>
          </FlexGrow>
        </FlexBox>
      </div>
    </Modal>
  );
};
